export const HARDWARE_ROUTE_PATH = '/jira/itam/ham';
